module.exports = "/_next/static/images/EnsureDataPrivacy-87c41d5ee6afd41cc506ad457c498a37.webp";